import { getUserIsKids } from './User';
import { store } from '../store';
import { getRegion } from './Region';
import { getClaroAdsKey } from './claroAds/getClaroAdskey';

export const getNavType = () => {
  const claroLiteConfig = getClaroAdsKey(store?.getState())
  const navType = store.getState().nav?.nav_type;
  if(claroLiteConfig && navType) return navType; 
  const isKids = getUserIsKids();
  return isKids ? 'kids' : 'newnav';
};

export const getNavTypeHomologacion = () => {
  const claroLiteConfig = getClaroAdsKey(store?.getState())
    const navType = store.getState().nav?.nav_type;
    console.log('navType',navType)
    if(navType) return navType; 

    else return 'newnav';
};
